import styled from 'styled-components';

export const StyledCard = styled.article`
  width: 25rem;
`;
